import type { JSX } from "react";

/**
 * Compact trend sparkline as a monochrome area + line (design-system Data Viz:
 * monochrome discipline, no brand flood). Colors come from the --cc-viz-* tokens
 * defined in console.css so light/dark stay consistent.
 */
export function Sparkline({ values, height = 40 }: { values: number[]; height?: number }): JSX.Element {
  const w = 240;
  const max = Math.max(1, ...values);
  const n = values.length;
  const step = n > 1 ? w / (n - 1) : w;
  const y = (v: number): number => height - (Math.max(0, v) / max) * (height - 2) - 1;
  const pts = values.map((v, i) => `${Math.round(i * step)} ${Math.round(y(v))}`);
  const line = pts.length > 0 ? `M ${pts.join(" L ")}` : "";
  const area = line.length > 0 ? `${line} L ${w} ${height} L 0 ${height} Z` : "";
  return (
    <svg viewBox={`0 0 ${w} ${height}`} preserveAspectRatio="none" className="cc-sparkline" style={{ height }} aria-hidden="true">
      <path d={area} fill="var(--cc-viz-soft)" stroke="none" />
      <path d={line} fill="none" stroke="var(--cc-viz-line)" strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
